import * as React from "react";
import * as PropTypes from "prop-types";
import { History } from "history";
import { Router, Switch } from "react-router-dom";
import App from "modules/app/containers/app";
import {NoAccessScreen, MainLoader } from "common/components";
import { PageMessage } from "@vidazoo/ui";
import { ScrollToTop } from "@vidazoo/ui-framework";
import { appUrlsService } from "common/services";
import {Route} from "react-router";

export interface IRootProps {
	isAuthenticating?: boolean;

	isAuthError?: boolean;

	isAuthTimeout?: boolean;

	history?: History;

	hasDataAccess?: boolean;
}

export interface IRootState {

}

export default class Root extends React.Component<IRootProps, IRootState> {
	public render(): JSX.Element {
		const { isAuthenticating, isAuthError, history, hasDataAccess } = this.props;

		if (isAuthenticating) {
			return (
				<MainLoader />
			);
		}

		// The token alone is not enough: without a session the server rejects
		// every request, so rendering the app would only look like it works.
		// A rejected token signs the user out, so this covers the rest.
		if (isAuthError) {
			return (
				<NoAccessScreen
					title="We couldn't load your session"
					description="Something went wrong while loading your account. Please try again, or sign out and sign in again."
				/>
			);
		}

		if (!hasDataAccess) {
			return (
				<NoAccessScreen />
			);
		}

		return (
			<React.Fragment>
				<Router history={history}>
					<React.Fragment>
						<ScrollToTop />
						<Switch>
							<Route path={appUrlsService.app()} component={App} />
						</Switch>
					</React.Fragment>
				</Router>
			</React.Fragment>
		);
	}
}
